import {Button, Tag} from 'antd';
import {useNavigate} from 'react-router-dom';
import {ROUTES} from '../../utils/ROUTES';

export function CandidateCard({imgSrc, imgAlt, name, role, skillsTag, experience}) {
	return (
		<div className="flex flex-col items-center justify-start gap-4 w-[250px] max-w-[450px] flex-grow mobile-width-100 bg-white p-6 rounded-lg shadow-border-no-background">
			<img src={imgSrc} alt={imgAlt} width={100} height={100} className="rounded-full h-[100px] w-[100px] object-cover shadow-border-chill-background bg-backgroundGreyBlue" />
			<div className="flex gap-3 flex-col  h-full">
				<div className="flex flex-col gap-1">
					<p className="text-sm">{name}</p>
					<p className="text-sm font-semibold">{role}</p>
					{experience && <p className="text-sm">{experience}</p>}
				</div>
				{skillsTag && (
					<div className="flex gap-2 flex-wrap justify-center items-center">
						{skillsTag.map((tag, index) => (
							<Tag key={index} className="m-0">
								{tag}
							</Tag>
						))}
					</div>
				)}
			</div>
		</div>
	);
}

export function CandidateSection({title, subtitle, candidates}) {
	const navigate = useNavigate();
	const handleClick = () => {
		navigate(ROUTES.POST_JOB);
	};

	// Use the provided candidates array or fallback to an empty array
	const displayCandidates = candidates || [];

	return (
		<div className="py-[100px] px-5 text-center bg-backgroundGreyBlue">
			<div className="max-w-[1300px] mx-auto flex flex-col gap-4">
				<h2 className="font-normal m-0 text-2xl text-darkCharcoal">{title}</h2>
				<p className="text-charcoal text-base font-light">{subtitle}</p>
				<div className="py-5 flex flex-wrap justify-center gap-[30px]">
					{displayCandidates.map((card: any, index: number) => (
						<CandidateCard key={index} {...card} />
					))}
				</div>
			</div>
			<Button type="primary" size="large" className="w-full sm:w-[300px] mt-5" onClick={handleClick}>
				Get Started
			</Button>
		</div>
	);
}
